import { rem } from "polished";
import styled from "styled-components";

import { device } from "../../../../../utils";

export const FormInput = styled.input<{ isUppercase?: boolean }>`
  width: 100%;
  font-family: ${({ theme }) => theme.type.fonts.main};
  font-size: ${({ theme }) => theme.type.sizes.size14};
  font-weight: 400;
  color: ${({ theme }) => theme.colours.textMain};
  border: none;
  padding: 0;
  padding-bottom: ${rem("2px")};
  vertical-align: middle;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${({ theme }) => theme.colours.textPlaceholder};
    opacity: 1;
    text-transform: none;
  }

  &::-ms-input-placeholder {
    color: ${({ theme }) => theme.colours.textPlaceholder};
  }

  ${({ isUppercase }) =>
    isUppercase &&
    `
    text-transform: uppercase;
    
  `}

  @media ${device.tablet} {
    font-size: ${({ theme }) => theme.type.sizes.size16};
  }
`;
